module.exports = __webpack_public_path__ + "img/ee.2cb22dc7.svg";